const actions = {
  FETCH_SESSIONS_REQUEST: "FETCH_SESSIONS_REQUEST",
  FETCH_SESSIONS_SUCCESS: "FETCH_SESSIONS_SUCCESS",
  FETCH_SESSIONS_ERROR: "FETCH_SESSIONS_ERROR",
  RESET_SESSIONS: "RESET_SESSIONS",
  SCHEDULE_A_SESSION: "SCHEDULE_A_SESSION",
  SUSPEND_A_SESSION: "SUSPEND_A_SESSION",
  fetch: (role, params) => ({
    type: actions.FETCH_SESSIONS_REQUEST,
    role,
    params,
  }),
  scheduleSession: (data) => ({
    type: actions.SCHEDULE_A_SESSION,
    data,
  }),
  suspendSession: (id) => ({
    type: actions.SUSPEND_A_SESSION,
    id,
  }),
  reset: () => ({
    type: actions.RESET_SESSIONS,
  }),
};
export default actions;
